module.exports = __webpack_public_path__ + "static/media/room-lookboard.fffd7a8c.jpg";